const colors = {
  brand: {
    primary: '#e51937',
    secondary: '#373737',
    border: '#ddd',
    disabled: '#D1D3D4',
    info: '#7DD3FC',
    warning: '#FFD87E',
    error: '#B50323',
    success: '#86EFAC',
    toast: '#0369A1',
    popover: '#BAE6FD',
    active: '#0066F5',
    activeBg: '#EBF8FF',
    gray2: '#58595B',
    lightGray2: '#D1D3D4',
    lightGray3: '#F1F2F2',
  },
  notice: {
    error: {
      bg: '#FFE7E9',
      border: '#E51937',
      textColor: '#373737',
      iconColor: '#E51937',
    },
    warning: {
      bg: '#FFFAEA',
      border: '#DCA019',
      textColor: '#373737',
      iconColor: '#DCA019',
    },
    success: {
      bg: '#F4FFF4',
      border: '#144928',
      textColor: '#373737',
      iconColor: '#144928',
    },
    info: {
      bg: '#EBF8FF',
      border: '#0066F5',
      textColor: '#373737',
      iconColor: '#0066F5',
    },
    messageLight: {
      bg: '#F8F9F9',
      border: '#D1D3D4',
      textColor: '#373737',
      iconColor: '#000000',
    },
    messageDark: {
      bg: '#373737',
      border: '#F1F2F2',
      textColor: '#FFFFFF',
      iconColor: '#FFFFFF',
    },
  },
  primary: {
    100: '#FBDDDF',
    200: '#FBDDDD',
    300: '#F6ACAD',
    400: '#F07B82',
    500: '#EB4A5B',
    600: '#e51937',
    700: '#C91530',
    800: '#AD1229',
    900: '#900F22',
  },
  secondary: {
    100: '#777777',
    200: '#676767',
    300: '#575757',
    400: '#474747',
    500: '#373737',
    600: '#272727',
    700: '#171717',
    800: '#070707',
    900: '#000',
  },
  darkSecondary: {
    100: '#fff',
    200: '#fff',
    300: '#fff',
    400: '#fff',
    500: '#fff',
    600: '#fff',
    700: '#fff',
    800: '#fff',
    900: '#fff',
  },
};

export default colors;
